import React, {Component} from 'react';
import PropTypes from 'prop-types'
import NotificationSystem from 'react-notification-system';
import $ from 'jquery';
import 'fullcalendar';
//import '../../../assets/css/fullcalendar.css'
import '../../../assets/css/fullcalendar.min.css'
import FullCalendar from 'fullcalendar-reactwrapper';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '../../../assets/css/slider.css'
import {BeatLoader} from 'react-spinners'
import {MONTH,currency_symbol} from "../../../server/constants";
import {get} from "../../../server/actionsParent";
import Modal from 'react-modal';
import moment from  'moment';
import {convertUTCDateToLocalDate,standardDateFormat,getGradeNumberByText, _addNotificationError, gradeTextToNumber} from "../../../server/util";
let isMobile = false;
const customStyles = {
    content: {
        textAlign: 'justify',
        textJustify: 'inter-word',
        padding: '30px',
        maxHeight: '500px',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '30%',
        transform: 'translate(-50%, -50%)'
    }
};
Date.prototype.addHours = function (h) {
    this.setHours(this.getHours() + h);
    return this;
};
// window.onbeforeunload = function(e){
//     return 'Dialog text here.';
// };
let scrollY = 0;
let scrollX=  0;

let dot = {
    backgroundColor: '#b2e87a',
    height: '20px',
    width: '20px',
    borderRadius: '50%',
    display: 'inline-block',
    margin: '0px 10px',
    verticalAlign: 'middle'

}
let allergyDot = {
    backgroundColor: '#85abec',
    height: '20px',
    width: '20px',
    borderRadius: '50%',
    display: 'inline-block',
    marginRight: '10px'

}
let dot2 = {
    backgroundColor: 'orange',
    height: '20px',
    width: '20px',
    borderRadius: '50%',
    display: 'inline-block',
    margin: '0px 10px',
    verticalAlign: 'middle'

}
let dot3 = {
    backgroundColor: '#ea7066',
    height: '20px',
    width: '20px',
    borderRadius: '50%',
    display: 'inline-block',
    margin: '0px 10px',
    verticalAlign: 'middle'

};
let dot4 = {
    height: '25px',
    width: '25px',
    border: 'solid 2px',
    borderRadius: '50%',
    display: 'inline-block',
    margin: '0px 7px',
    verticalAlign: 'middle'
};

function findAllergies(allergies, itemDesc) {
    let res = allergies.replace(/[, ]+/g, " ").trim();
    let parts = res.split(' ')
    let x = parts.map(allergy => {
        return findAllergy(allergy, itemDesc)
    })
    if (x.indexOf(true) >= 0) {
        return true
    } else return false
}

function aContainsB(a, b) {
    return a.match(b);
}

function findAllergy(allergy, itemDesc) {
    if (aContainsB(itemDesc, allergy)) {
        return true
    } else {
        return false
    }
}

class orderMealV3 extends Component {
    componentWillMount = () => {
       
        console.log(this.props.mealMonth)
        window.addEventListener('resize', this.handleWindowSizeChange);
        let canOrder = ''
        //let parts = this.props.cutoff.split(/[T]/)
        //let part2 = parts[0].split('-')
        //let cutoff = (new Date(part2[0], part2[1] - 1, part2[2], 0, 0, 0));
        let cutoff=this.props.cutoff==undefined?new Date(): moment(this.props.cutoff).toDate() //standardDateFormat(this.props.cutoff);

        //if ((new Date() <= new Date(cutoff)) || (new Date() > new Date(cutoff) && this.props.canOrderAfterCutoff)) {
            if ((new Date() <= cutoff) || this.props.canOrderAfterCutoff) {
            canOrder = true
        } else {
            if (sessionStorage.getItem('ROLE') == 'ROLE_ADMIN') {
                canOrder = true;
            } else {
                canOrder = false;
                this.setState({isCutoffModeOpen:true});//('You can not order menu as cut-off date time exceeded.',this);
            }         
        }

        if (sessionStorage.getItem('Menu') && sessionStorage.getItem('Price')) {
            this.setState({
                menu: this.convertStringDateTodate(JSON.parse(sessionStorage.getItem('Menu'))),
                price: parseFloat(sessionStorage.getItem('Price'))==NaN?0.00:parseFloat(sessionStorage.getItem('Price')),
                loading: true,
                canOrder: canOrder
            }, () => {
                if (this.props.reducedPriceStatus) {
                    this.getReducedPrice()
                }
                this.getPreviousOrders()
            });
        }
        else {
            let allergyAlertTrue = ''
            this.props.mealList.forEach((event, idx) => {
                try {
                    if(event.desc!==null&&(this.props.allergies==''?null:this.props.allergies)!==null){
                        event.allergyAlert = findAllergies(this.props.allergies.toLowerCase(), event.desc.toLowerCase())
                        if (event.allergyAlert) {
                            allergyAlertTrue = true;
                        }
                    }
                } catch (e) {
                    console.log("Error in finding allergies", e)
                }

                event["eventId"] = idx;
                if (event.type === "SIDE") {
                    event.start = new Date(event.start).addHours(1);
                }


            });
            this.setState({
                allregyAlertModal: allergyAlertTrue,
                canOrder: canOrder,
                loading: true,
                menu: this.props.mealList, price: this.props.price,
            }, () => {
                if (this.props.reducedPriceStatus) {
                    this.getReducedPrice()
                }
                this.getPreviousOrders()
            });

        }
        this.getSchoolInfo(this.props.studentData._links.studentUser.href.split('/').pop());
    };

    convertStringDateTodate(mealList){
        let finalMealList=[];
        mealList.forEach(function(mealitem){
            mealitem.start=new Date(mealitem.start)
            finalMealList.push(mealitem);
        });
        return finalMealList;
    }

    getSchoolInfo = (id) => {
        this.setState({loading:true})
        get('/studentUsers/' + id + '/mealSchool?access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            this.setState({
                loading:false,
                schoolInfoDomain: data.subdomain,
                schoolInfoContact: data.contactPPhone
            })
        }).catch(
            (error) => {
                this.setState({loading:false})
                console.log('Get School Info response', error)
            }
        )
    }
    getReducedPrice = () => {
        let redPrice = 0;
        let requests = this.state.menu.map(meal => {
            if (meal.type === "MEAL" && meal.isSelected) {
                return new Promise((resolve) => {
                    resolve();
                    redPrice = redPrice + meal.reducedPrice;
                })
            }
        })
        Promise.all(requests).then(() => {
            this.setState({reducedPrice: redPrice})
        })


    }
    getPreviousOrders = () => {
        let mealMonth = this.props.mealMonth.year + '' + (('0' + this.props.mealMonth.month).slice(-2));
        //alert(mealMonth)
        let prevMonth = [1, 2, 3].map(num => {
            if (this.props.mealMonth.month - num <= 0) {
                return this.props.mealMonth.year - 1 + '' + (('0' + (12 + (this.props.mealMonth.month - num))).slice(-2));

            } else {
                return this.props.mealMonth.year + '' + (('0' + (this.props.mealMonth.month - num)).slice(-2));

            }
        })
        let orderHistory = {}
        let studentId = this.props.studentData._links.studentUser.href.split('/').pop();
        let requests = prevMonth.map(month => {
            return new Promise((resolve) => {
                this.getOrder(month, studentId, orderHistory, resolve);
            })
        })
        Promise.all(requests).then(() => {
            this.setState({
                orderHistory: orderHistory,
                loading: false
            }, () => console.log(JSON.stringify(this.state.orderHistory, null, 2)))
        });


    }
    getOrder = (month, studentId, orderHistory, resolve) => {
        this.setState({loading:true})
        get('/mealOrderDetails/search/findByStudentUserUserIdAndYearMonth?studentRecId=' + studentId + '&yearMonth=' + month + '&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(res => {
           
            let orderId = res._links.mealOrderDetails.href.split('/').pop();
            if (orderId !== null && orderId !== '' && orderId !== undefined) {
                this.setState({loading:true})
                get('/mealOrderDetailses/' + orderId + '/schoolMeals?access_token=').then((response) => {
                    if (!response.ok) {
                        throw Error(response.statusText);
                    }
                    console.log('response', response);
                    return response.json();
                }).then(data => {

                    let x = [];
                    data._embedded.schoolMeals.forEach(meal => {
                        let item = {};
                        item.id = meal._links.self.href.split('/').pop();
                        item.title = meal.mealMenu.title;
                        item.type = meal.mealMenu.type;
                        let sdate=(meal.mealMenu.start?meal.mealMenu.start.substr(0,10).replace(/-/g , "/"):null);
                        
                        item.start = convertUTCDateToLocalDate(new Date(sdate));
                        item.desc = meal.mealMenu.desc;
                        item.price = meal.mealMenu.price;

                        if (meal.mealMenu.type === "MEAL") {
                            item.isSelected = true;
                        } else if (meal.mealMenu.type === "SIDE") {
                            item.isSelected = true;
                            item.start = item.start.addHours(1);
                        }
                        //alert(x.mealMenu.start)
                        // alert(item.start)
                        x.push(item);

                    });
                    orderHistory[month] = {"meals": x, "pdf": res.menuOrderedPdfLink};
                    //console.clear();
                    // alert(month)
                    //this.setState({orderHistory: {...this.state.orderHistory, [month]: x}})
                    this.setState({loading:false})
                    console.log(JSON.stringify(this.state.orderHistory))
                    resolve();
                }).catch(
                    (error) => {
                        this.setState({loading:false})
                        console.log('Get Order History response', error)
                    }
                )
            }
            this.setState({loading:false})
        }).catch(
            (error) => {
                resolve();
                this.setState({loading:false})
                console.log('Get Meal Menu response', error)
            }
        )

    }    
    reviewOrder = () => {
        console.log(this.state.menu);
        sessionStorage.setItem('Menu', JSON.stringify(this.state.menu));
        sessionStorage.setItem('Price', this.state.price);
        this.props.review(this.state.menu, this.state.price);
    }
    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
        window.addEventListener("beforeunload", this.onUnload)
    }

    componentWillUnmount = () => {
        // $(window).off('scroll');
        window.removeEventListener("beforeunload", this.onUnload)
        window.removeEventListener('resize', this.handleWindowSizeChange);

    }
    handleWindowSizeChange = () => {
        this.setState({width: window.innerWidth});
    };
    onUnload = (event) => { // the method that will be used for both add and remove event
        event.returnValue = "You may loose data if you leave the page"
    }


    orderEventStyles = (event, element, view) => {
        //alert(JSON.stringify(event,null,2))

        if (event.type === "MEAL") {
                return $('<div style="cursor:pointer;height:auto;text-align:center;background-color:inherit;border-radius:25px;' +
                'white-space: pre-wrap;color: black;font-size:13px;padding:5px;font-weight: bolder;margin-bottom: 5px">'
                + event.title + " " + currency_symbol()
                 + (this.props.studentIsFreeMeal? 0: (this.props.studentIsReducePrice && this.props.reducedPriceStatus)?event.reducedPrice:  event.price) + '</div>');
        }
        else if (event.type === "SIDE") {
            element.css('background-color', 'inherit');
            element.css('border', '0px');
            element.css('font-weight', 'bolder');
            element.css('white-space', 'pre-wrap');
            element.css('color', 'red');
            element.css('font-size', '12px');
            element.css(' margin-bottom', '-5px');
        }
        else {
            element.css('background-color', 'inherit');
            element.css('color', 'black');
            element.css('border', '0px');
        }


    }
    componentWillUpdate = () => {
        //alert("Will update")
        
        scrollX=$(document).find('#mCal').parent().scrollLeft()||0;
        
        scrollY = $(document).scrollTop();
    }
    componentDidUpdate = () => {
        // alert("Did update")
        $(document).find('#mCal').parent().scrollLeft(scrollX);
        
        window.scrollTo(scrollX, scrollY);
        if (!isMobile){
            this.slider.slickGoTo(Object.keys(this.state.orderHistory).length || 0);
        }   
    }

    
    constructor(props) {
        super(props);
        this.state = {
            allregyAlertModal: false,
            isCutoffModeOpen:false,
            x: 1,
            canOrder: '',
            menu: [],
            price: 0,
            mealList: [],
            loading: true,
            orderHistory: {},
            width: window.innerWidth,
            reducedPrice: null,
            schoolInfoDomain: '',
            schoolInfoContact: ''    
        }
        

        this.selectEvent = this.selectEvent.bind(this);
        this.resetOrders = this.resetOrders.bind(this);
        this.eventStyles = this.eventStyles.bind(this);
        this.setPrice = this.setPrice.bind(this);
        this.convertStringDateTodate=this.convertStringDateTodate.bind()

    }

    setPrice(price, action) {
        if (action === "ADD") {
            this.setState({
                price: this.state.price + price
            })
        } else if (action === "MINUS") {
            this.setState({
                price: this.state.price - price
            })
        }

    }

    resetOrders() {
        const nextEvents = [...this.state.menu]
        this.state.menu.forEach(event => {
            if (event.isSelected) {
                const idx = this.state.menu.indexOf(event);
                let updatedEvent = {...event, isSelected: !event.isSelected}
                //  alert(JSON.stringify(updatedEvent,null,2))
                nextEvents.splice(idx, 1, updatedEvent)
            }
        });
        this.setState({
            price: 0,
            menu: nextEvents,
            reducedPrice: 0
        })


    }

    selectEvent=(calEvent, jsEvent, view)=> {
        jsEvent.preventDefault();
        jsEvent.stopPropagation();
        if(calEvent.start._d<new Date(new Date().getFullYear(),new Date().getMonth(),new Date().getDate())){
            return
        }
        if (calEvent.type == "MEAL") {
            const idx = this.state.menu.findIndex(x => x.eventId === calEvent.eventId);
            let updatedEvent = {...this.state.menu[idx], isSelected: !calEvent.isSelected}
            const nextEvents = [...this.state.menu]
            let calDate = calEvent.start._d;
            let calTitle = calEvent.title;
            nextEvents.splice(idx, 1, updatedEvent);
            if(this.props.studentIsFreeMeal){
                if (updatedEvent.isSelected) {                  
                    Object.keys(this.state.menu).map(item => {                      
                        if(this.state.menu[item].start.toString() == calDate.toString()){                          
                            if(!(this.state.menu[item].title == calTitle)){
                                if(this.state.menu[item].isSelected == true){                                   
                                    updatedEvent = {...this.state.menu[item], isSelected: false}
                                    nextEvents.splice(item, 1, updatedEvent)
                                    this.setState({
                                        price: 0,
                                        menu: nextEvents
                                    })
                                } 
                            }
                        }
                    });
                    
                    this.setState({
                        price: 0,
                        menu: nextEvents
                    })
                } else {
                    this.setState({

                        price: 0,
                        menu: nextEvents
                    })

                }

            }
            else if(this.props.studentIsReducePrice && this.props.reducedPriceStatus){
                if (updatedEvent.isSelected) {
                            Object.keys(this.state.menu).map(item => {                      
                                if(this.state.menu[item].start.toString() == calDate.toString()){                          
                                    if(!(this.state.menu[item].title == calTitle)){
                                        if(this.state.menu[item].isSelected == true){                                   
                                            updatedEvent = {...this.state.menu[item], isSelected: false}
                                            nextEvents.splice(item, 1, updatedEvent)
                                            this.setState({
                                                price: this.state.price - (updatedEvent.reducedPrice?updatedEvent.reducedPrice:0),
                                                menu: nextEvents
                                            })
                                        } 
                                    }
                                }
                            }); 
                            this.setState({
                                price: this.state.price + (updatedEvent.reducedPrice?updatedEvent.reducedPrice:0),
                                menu: nextEvents
                            })
                        } else {
                            this.setState({
                                price: this.state.price - (updatedEvent.reducedPrice?updatedEvent.reducedPrice:0),
                                menu: nextEvents
                            })
        
                        }
        
              }
            else{
                if (updatedEvent.isSelected) {                  
                            Object.keys(this.state.menu).map(item => {                      
                                if(this.state.menu[item].start.toString() == calDate.toString()){                          
                                    if(!(this.state.menu[item].title == calTitle)){
                                        if(this.state.menu[item].isSelected == true){                                   
                                            updatedEvent = {...this.state.menu[item], isSelected: false}
                                            nextEvents.splice(item, 1, updatedEvent)
                                            this.setState({
                                                price: this.state.price - updatedEvent.price,
                                                menu: nextEvents
                                            })
                                        } 
                                    }
                                }
                            });                            
                            this.setState({
                                price: this.state.price + updatedEvent.price,
                                menu: nextEvents
                            })
                        } else {
                            this.setState({        
                                price: this.state.price - updatedEvent.price,
                                menu: nextEvents
                            })        
                        }
            }           
        } else if(calEvent.type == "SIDE"){
            const idx = this.state.menu.findIndex(x => x.eventId === calEvent.eventId);
            let updatedEvent = {...this.state.menu[idx], isSelected: !calEvent.isSelected}
            const nextEvents = [...this.state.menu]
            let calDate = calEvent.start;
            let calTitle = calEvent.title;
            nextEvents.splice(idx, 1, updatedEvent);
             
            if (updatedEvent.isSelected) { 
                let isMenuSelected=false;
                isMenuSelected=(this.state.menu||[]).some(item => {
                if (moment(item.start).format('DD-MM-YYYY') == moment(calEvent.start).format('DD-MM-YYYY') 
                && item.type=='MEAL' && item.isSelected == true)
                {    
                    return true;
                }
                return false;
                });
                if(!isMenuSelected){
                    _addNotificationError('Please select Entree item first on ('+ moment(calEvent.start).format('DD-MM-YYYY')+').',this)
                    return false;
                }                 
                Object.keys(this.state.menu).map(item => {                      
                    if(moment(this.state.menu[item].start).format('DD-MM-YYYY') == moment(calDate).format('DD-MM-YYYY') && this.state.menu[item].type == "SIDE"){                          
                        if(!(this.state.menu[item].title == calTitle)){
                            if(this.state.menu[item].isSelected == true){                                   
                                updatedEvent = {...this.state.menu[item], isSelected: false}
                                nextEvents.splice(item, 1, updatedEvent)
                                this.setState({
                                    menu: nextEvents
                                })
                            } 
                        }
                    }
                });                            
                this.setState({
                    menu: nextEvents
                })
            } else {
                this.setState({ 
                    menu: nextEvents
                })        
            }

        }
    }
    eventStyles(event, element, view) {        
        if (event.type === "MEAL" && !event.isSelected) { 
            if(event.start._d<new Date(new Date().getFullYear(),new Date().getMonth(),new Date().getDate())){
                return $('<a href="#" title="' + event.desc + '"></span><div class="calender-menu-item-1" style="background-color: #e9efe3;"> M : '
                            + event.title + "  " + currency_symbol() 
                            + (this.props.studentIsFreeMeal? 0: (this.props.studentIsReducePrice && this.props.reducedPriceStatus)?event.reducedPrice:  event.price) + '</div></a>');

            }           
            if (event.desc !== null && event.desc !== '') {
                //
                if (event.allergyAlert !== null && event.allergyAlert !== undefined && event.allergyAlert !== '' && event.allergyAlert) {
    
                    return $('<a href="#" title="' + event.desc + '"><div class="calender-menu-item-1" style="background-color: #85abec;"> M : '
                        + event.title + "  " + currency_symbol() 
                        + (this.props.studentIsFreeMeal? 0: (this.props.studentIsReducePrice && this.props.reducedPriceStatus)?event.reducedPrice:  event.price) + '</div></a>');
                } else {
                    return $('<a href="#" title="' + event.desc + '"><div class="calender-menu-item-1"> M : '
                        + event.title + "  " + currency_symbol() 
                        + (this.props.studentIsFreeMeal? 0: (this.props.studentIsReducePrice && this.props.reducedPriceStatus)?event.reducedPrice:  event.price) + '</div></a>');
                }
                //event.color = "#FFB347"; //Em andamento
            } else {
                return $('<div class="eventip calender-menu-item-2"> M : '
                    + event.title + "  " + currency_symbol() + (this.props.studentIsFreeMeal? 0: (this.props.studentIsReducePrice && this.props.reducedPriceStatus)?event.reducedPrice:  event.price) + '</div>');
            }
        }      
       else if (event.type === "MEAL" && event.isSelected) { 
           if(event.start._d<new Date(new Date().getFullYear(),new Date().getMonth(),new Date().getDate())){ 
            return $('<a href="#" title="' + (event.desc == undefined ? '': event.desc) + '"><div class="calender-menu-item-3" style="background-color: #ecd5a9;"> M : '
            + event.title + "  " + currency_symbol() + (this.props.studentIsFreeMeal? 0: (this.props.studentIsReducePrice && this.props.reducedPriceStatus)?event.reducedPrice:  event.price) + '</div></a>');
           }
           else
           {
            return $('<a href="#" title="' + (event.desc == undefined ? '': event.desc) + '"><div class="calender-menu-item-3"> M : '
            + event.title + "  " + currency_symbol() + (this.props.studentIsFreeMeal? 0: (this.props.studentIsReducePrice && this.props.reducedPriceStatus)?event.reducedPrice:  event.price) + '</div></a>');  
           }               
        }
        else if (event.type === "SIDE") {
            if(this.props.isSideSelect){
                if (!event.isSelected) {
                    if(event.start._d<new Date(new Date().getFullYear(),new Date().getMonth(),new Date().getDate())){ 
                        return $('<a href="#" title="' + event.desc + '"><div class="calender-menu-item-1" style="background-color: #e9efe3;"> S : '
                                    + event.title + '</div></a>');
        
                    }else {
                        return $('<div class="eventip calender-menu-item-2"> S : '
                            + event.title +'</div>');
                    }
                }else{
                    if(event.start._d<new Date(new Date().getFullYear(),new Date().getMonth(),new Date().getDate())){ 
                        return $('<a href="#" title="' + (event.desc == undefined ? '': event.desc) + '"><div class="calender-menu-item-3" style="background-color: #ecd5a9;"> S : '
                        + event.title + '</div></a>');
                       }
                       else
                       {
                        return $('<a href="#" title="' + (event.desc == undefined ? '': event.desc) + '"><div class="calender-menu-item-3"> S : '+ event.title + '</div></a>');  
                       }

                }

            }else{
                return $('<div style="border:0px; font-weight:bolder; white-space:pre-wrap; color:red; font-size:12px; margin-bottom:-5px;"> S : '
            + event.title + '</div>');  
                /* element.css('background-color', 'inherit');
                element.css('border', '0px');
                element.css('font-weight', 'bolder');
                element.css('white-space', 'pre-wrap');
                element.css('color', 'red');
                element.css('font-size', '12px');
                element.css(' margin-bottom', '-5px'); */
            }
        }  
    }

    render() {
        const {width} = this.state;
        //const isMobile = width <= 500;
        isMobile = width <= 500;
        var settings = {
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            //initialSlide: 1,
            lazyLoad: true
        };
        if (isMobile) {
            return (
                <div className="">
                <NotificationSystem ref="notificationSystem"/> 
                <div style={{    paddingBottom: '43px'}}>
                            <button className="pull-right btn bg-color-4" style={{margin:'0px',color:'#ffffff'}} onClick={(e) => {
                                e.preventDefault();
                                if (sessionStorage.getItem('ROLE') == 'ROLE_ADMIN') {                                   
                                        this.context.router.history.push('/schoolAdmin/viewOrdersGrid')                                    
                                }
                                else{
                                    this.context.router.history.push('/parent')
                                }
                            }}><i class="fa fa-arrow-circle-left" aria-hidden="true"></i> Back</button>
                    </div>
                    <div className='sweet-loading' style={{position: 'fixed', top: '50%', left: '50%'}}>
                        <BeatLoader
                            size={20}
                            color={'#ea7066'}
                            loading={this.state.loading}
                        />
                    </div>                    
                    <Modal
                        isOpen={this.state.allregyAlertModal}
                        style={customStyles}
                        contentLabel="Activation"
                        ariaHideApp={false}
                    >
                        <div className="row text-center">
                            <h5 style={{color: 'red'}}>Possible allergy alert</h5>
                        </div>
                        <div>
                            <p>Our system has found some meals with description that matched your kid's allergies.
                                Those meals are highlighted with &nbsp; <span
                                    style={allergyDot}></span><span>Color.</span></p>
                            <p><b>Disclaimer:</b><br/>
                                <strong>By Selecting the meals contaning the allergy items, you consent to the fact
                                    that
                                    school
                                    would serve the meal that day and
                                    they do not have to replace it. Additional information is needed. Please contact <span style={{textTransform:'uppercase'}}>{this.state.schoolInfoDomain}</span> Food Service Manager at {this.state.schoolInfoContact}.</strong>
                            </p>
                            <div className="row text-center">
                                <button style={{margin: '0px'}}
                                        className="btn btn-success btn-sm "
                                        onClick={() => this.setState({allregyAlertModal: false})}>
                                    <i className="glyphicon glyphicon-ok"></i> Okay
                                </button>
                            </div>
                        </div>
                    </Modal>
                    <Modal
                        isOpen={this.state.isCutoffModeOpen}
                        style={customStyles}
                        contentLabel="Activation"
                        ariaHideApp={false}
                    >
                        <div className="row text-center">
                            <h5 style={{color: 'red'}}>Info</h5>
                        </div>
                        <div>
                            <p>You can not order menu as cut-off date time exceeded.</p>
                            
                            <div className="row text-center">
                                <button style={{margin: '0px'}}
                                        className="btn btn-success btn-sm "
                                        onClick={() => this.setState({isCutoffModeOpen: false})}>
                                    <i className="glyphicon glyphicon-ok"></i> Okay
                                </button>
                            </div>
                        </div>
                    </Modal>

                    <div className="row" style={{margin: '0'}}>
                        <div className="order-meal-header capitalize">
                            <div className="col-sm-4">
                                <p>Name: <span>{this.props.studentData.firstName + ' ' + this.props.studentData.lastName}</span>
                                </p>
                            </div>
                            <div className="col-sm-6">
                                <p>School: <span>{this.props.studentData.schoolName}</span></p>
                            </div>
                            <div className="col-sm-2">
                                <p>Grade: <span>{gradeTextToNumber(this.props.studentData.gradeName)}</span></p>
                            </div>
                            <div className="col-md-6 col-sm-6"></div>
                        </div>
                    </div>

                    <div id="myID" className="bottomMenu show">
                        <p className="text-center"
                           style={{color: 'red', fontSize: '12px'}}>
                            Order Amount : <span
                            style={{fontSize: '20px'}}>{currency_symbol()+''+parseFloat(this.state.price).toFixed(2)} </span></p>
                    </div>

                    <div className="row">
                        <div className="col-xs-12 text-center">
                                <h4 style={{marginBottom:'5px'}}>{MONTH[this.props.mealMonth.month - 1]} {this.props.mealMonth.year}</h4>
                                <div className="col-xs-12">
                                <span style={dot}></span>
                                <span>Available</span>
                                
                                <span style={dot2}></span>
                                <span>Selected</span>
                                
                                <span style={dot4}>M</span><span>Main course</span>
                                <span style={dot4}>S</span><span>Sides</span>
                                </div>
                                {/* </div> */}
                                <div className="clearfix"></div>
                            {/* <i><b style={{fontSize: '12px'}}>Swipe left to view previous orders</b></i> */}
                            <div className="table-responsive">
                                <FullCalendar id='mCal'
                                    height="auto"
									//defaultView="listMonth"
                                    defaultDate={new Date(this.props.mealMonth.year, this.props.mealMonth.month - 1, 1)}
                                    themeSystem='bootstrap3'
                                    header={false}
                                    weekends={false}
                                    editable={false}
                                    resizable={false}
                                    eventClick={this.state.canOrder ? this.selectEvent : ''}
                                    events={this.state.menu}
                                    displayEventTime={false}
                                    fixedWeekCount={false}
                                    // droppable: true, // this allows things to be dropped onto the calendar
                                    eventRender={this.eventStyles}
                                />
                            </div>
                            {this.state.canOrder &&
                            <div className="col-md-12 text-center calendar-footer-buttons">
                                <div className="col-md-6 col-sm-6 col-xs-6" style={{padding: '0px'}}>
                                    <button onClick={this.resetOrders}
                                            className="btn btn-danger btn-sm pull-right"> Reset
                                    </button>
                                </div>
                                <div className="col-md-6 col-sm-6 col-xs-6" style={{padding: '0px'}}>
                                    <button className="btn btn-success btn-sm pull-left"
                                            onClick={this.reviewOrder}> Finish
                                        & Review
                                    </button>
                                </div>
                            </div>
                            }
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="">
                <NotificationSystem ref="notificationSystem"/> 
                    <div className='sweet-loading' style={{position: 'fixed', top: '50%', left: '50%'}}>
                        <BeatLoader
                            size={20}
                            color={'#ea7066'}
                            loading={this.state.loading}
                        />
                    </div>
                    <div style={{    paddingBottom: '43px'}}>
                            <button className="pull-right btn bg-color-4" style={{margin:'0px',color:'#ffffff'}} onClick={(e) => {
                                e.preventDefault();
                                let _self=this;
                                _self.context.router.history.goBack() ; 
                            }}><i class="fa fa-arrow-circle-left" aria-hidden="true"></i> Back</button>
                    </div>
                    <Modal
                        isOpen={this.state.allregyAlertModal}
                        style={customStyles}
                        contentLabel="Activation"
                        ariaHideApp={false}
                    >
                        <div className="row text-center">
                            <h5 style={{color: 'red'}}>Possible allergy alert</h5>
                        </div>
                        <div>
                            <p>Our system has found some meals with description that matched your kid's allergies.
                                Those meals are highlighted with &nbsp; <span
                                    style={allergyDot}></span><span>Color.</span></p>
                            <p><b>Disclaimer:</b><br/>
                                <strong>By Selecting the meals contaning the allergy items, you consent to the fact
                                    that
                                    school
                                    would serve the meal that day and
                                    they do not have to replace it. Additional information is needed. Please contact <span style={{textTransform:'uppercase'}}>{this.state.schoolInfoDomain}</span> Food Service Manager at {this.state.schoolInfoContact}.</strong>
                            </p>
                            <div className="row text-center">
                                <button style={{margin: '0px'}}
                                        className="btn btn-success btn-sm "
                                        onClick={() => this.setState({allregyAlertModal: false})}>
                                    <i className="glyphicon glyphicon-ok"></i> Okay
                                </button>
                            </div>
                        </div>
                    </Modal>
                    <Modal
                        isOpen={this.state.isCutoffModeOpen}
                        style={customStyles}
                        contentLabel="Activation"
                        ariaHideApp={false}
                    >
                        <div className="row text-center">
                            <h5 style={{color: 'red'}}>Info</h5>
                        </div>
                        <div>
                            <p>You can not order menu as cut-off date time exceeded.</p>
                            
                            <div className="row text-center">
                                <button style={{margin: '0px'}}
                                        className="btn btn-success btn-sm "
                                        onClick={() => this.setState({isCutoffModeOpen: false})}>
                                    <i className="glyphicon glyphicon-ok"></i> Okay
                                </button>
                            </div>
                        </div>
                    </Modal>    

                    <div className="row" style={{margin: '0'}}>
                        <div className="order-meal-header capitalize">
                            <div className="col-sm-4">
                                <p>Name: <span>{this.props.studentData.firstName + ' ' + this.props.studentData.lastName}</span>
                                </p>
                            </div>
                            <div className="col-sm-6">
                                <p>School: <span>{this.props.studentData.schoolName}</span></p>
                            </div>
                            <div className="col-sm-2">
                                <p>Grade: <span>{gradeTextToNumber(this.props.studentData.gradeName)}</span></p>
                            </div>
                            <div className="col-md-6 col-sm-6"></div>
                        </div>
                    </div>

                    <div id="myID" className="bottomMenu show">
                        <p className="text-center"
                           style={{color: 'red', fontSize: '12px'}}>
                            Order Amount : <span
                            style={{fontSize: '20px'}}>{currency_symbol()+''+parseFloat(this.state.price).toFixed(2)} </span></p>
                        

                    </div>

                    <Slider ref={slider => (this.slider = slider)} {...settings} >
                        {Object.keys(this.state.orderHistory).map((key) => {
                            
                            return <div className="row slide">
                                <div className="col-xs-12 text-center">
                                    <div className="row">
                                        <h4
                                            className="col-lg-6 col-lg-offset-3">{MONTH[key.slice(-2) - 1]} {key.substring(0, 4)}</h4>
                                        <a className="col-lg-3 col-xs-6 "
                                           href={this.state.orderHistory[key].pdf} target="_blank" download>
                                            <button type="button" style={{marginBottom: '5px'}}
                                                    className="pull-right btn-social btn-linkedin-filled btn-rounded ">
                                                <i class="fa fa-file-pdf-o"></i> Download PDF
                                            </button>
                                        </a>
                                    </div>

                                    <FullCalendar
                                        height="auto"
                                        defaultDate={new Date(key.substring(0, 4), key.slice(-2) - 1, 1)}
                                        themeSystem='bootstrap3'
                                        header={false}
                                        weekends={false}
                                        editable={false}
                                        resizable={false}
                                        events={this.state.orderHistory[key].meals}
                                       
                                        displayEventTime={false}
                                        fixedWeekCount={false}
                                        // droppable: true, // this allows things to be dropped onto the calendar
                                        eventRender={this.orderEventStyles}
                                    /> 
                                </div>

                            </div>
                        })}
                        <div className="row">
                            <div className="col-xs-12 text-center">
                                {/*<div className="text-center">*/}
                                {/*</div>*/}
                                <div className="text-center" style={{margin: '10px'}}>
                                    <h4 className="pull-left">{MONTH[this.props.mealMonth.month - 1]} {this.props.mealMonth.year}</h4>
                                    <span
                                        style={dot}>&nbsp;</span><span>Available Meals.&nbsp;&nbsp;   </span><span
                                    style={dot2}>&nbsp;&nbsp;</span><span>Selected Meals &nbsp;&nbsp;</span>
                                    <span style={dot4}>M</span><span>Main course</span>
                                <span style={dot4}>S</span><span>Sides</span>
                                    </div>
                               {Object.keys(this.state.orderHistory).length>0?<i><b style={{fontSize: '12px'}}>Swipe left to view previous orders</b></i>:null} 
                                <div className="table-responsive col-md-12 col-xs-12">
                                    <FullCalendar
                                        height="auto"
                                        defaultDate={new Date(this.props.mealMonth.year, this.props.mealMonth.month - 1, 1)}
                                        themeSystem='bootstrap3'
                                        header={false}
                                        weekends={false}
                                        editable={false}
                                        resizable={false}
                                        eventClick={this.state.canOrder ? this.selectEvent : ''}
                                        events={this.state.menu}
                                        displayEventTime={false}
                                        fixedWeekCount={false}
                                        // droppable: true, // this allows things to be dropped onto the calendar
                                        eventRender={this.eventStyles}
                                    />
                                </div>
                                {/*<br/>*/}
                                {/*<h3 id="price" className="text-center" style={{color: '#0080ff'}}>Total Price : <span*/}
                                {/*style={{fontSize: '20px'}}>$</span> {this.state.price} </h3>*/}
                                {this.state.canOrder &&
                                <div className="col-md-12 text-center calendar-footer-buttons">
                                    <div className="col-md-6 col-sm-6 col-xs-6" style={{padding: '0px'}}>
                                        <button onClick={this.resetOrders}
                                                className="btn btn-danger btn-sm pull-right"> Reset
                                        </button>

                                    </div>
                                    <div className="col-md-6 col-sm-6 col-xs-6" style={{padding: '0px'}}>
                                        <button className="btn btn-success btn-sm pull-left"
                                               // onClick={this.reviewOrder}> Finish
                                               onClick={this.reviewOrder}> Finish
                                            & Review
                                        </button>
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    </Slider>
                </div>

            );
        }
    }
}
orderMealV3.contextTypes = {
    router: PropTypes.object.isRequired
}
export default orderMealV3;


// WEBPACK FOOTER //
// ./src/components/Parent/OrderMeals/orderMealsV3.js